/* global axios */
import ApiClient from './ApiClient';

class CrmTaskAPI extends ApiClient {
  constructor() {
    super('crm_tasks', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new CrmTaskAPI();
